import React, { useState } from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import { DatePicker, KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { css } from '@emotion/core';
import format from 'date-fns/format';
import DateFnsUtils from '@date-io/date-fns';
import zhTwLocale from 'date-fns/locale/zh-TW';
import zhCNLocale from 'date-fns/locale/zh-CN';
import enLocale from 'date-fns/locale/en-US';
import jaLocale from 'date-fns/locale/ja';
import ptLocale from 'date-fns/locale/pt-BR';
import esLocale from 'date-fns/locale/es';
import { below } from 'common/utils/breakpoint';
import { isInvalidDate } from 'client/components/FormContent/FieldList/FormDataManage/formValidate';
import { langTypes } from 'config/langType';

function ResponseDatePicker({
    error,
    style,
    name,
    value,
    onChange = () => {},
    onBlur,
    disabled,
    native,
    lang
}) {
    const [currentVal, setCurrentVal] = useState(() => {
        const date = new Date(value);
        return Number.isNaN(date.getTime()) ? null : date;
    });
    const year = new Date().getFullYear() + 10;
    function updateDate(newDate) {
        if (!newDate) {
            setCurrentVal(newDate);
            onChange(newDate);
        } else {
            const formattedDate = isInvalidDate(newDate) ? newDate : format(newDate, 'yyyy-MM-dd');
            setCurrentVal(formattedDate);
            onChange(formattedDate);
        }
    }

    const localeMap = {
        [langTypes.ZH_TW]: zhTwLocale,
        [langTypes.ZH_CN]: zhCNLocale,
        [langTypes.EN_US]: enLocale,
        [langTypes.JA_JP]: jaLocale,
        [langTypes.PT_BR]: ptLocale,
        [langTypes.ES_419]: esLocale
    };

    const locale = localeMap[lang] || localeMap[i18n.language];

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
            {native ? (
                <DatePicker
                    css={[css(inputStyle), css(style)]}
                    placeholder="YYYY-MM-DD"
                    name={name}
                    value={currentVal}
                    onChange={updateDate}
                    onBlur={onBlur}
                    disabled={disabled}
                    error={error}
                    format="yyyy-MM-dd"
                    maxDate={`${year}/12/31`}
                    InputProps={{
                        placeholder: 'YYYY-MM-DD'
                    }}
                    variant="inline"
                    onClose={onBlur}
                    autoOk
                    clearable
                    autoComplete="off"
                    invalidDateMessage=""
                    maxDateMessage=""
                    minDateMessage=""
                    cancelLabel={i18n.t('button.label.cancel')}
                    okLabel={''}
                    clearLabel={i18n.t('button.label.clear')}
                />
            ) : (
                <KeyboardDatePicker
                    css={[css(inputStyle), css(style)]}
                    format="yyyy-MM-dd"
                    maxDate={`${year}/12/31`}
                    InputProps={{
                        placeholder: 'YYYY-MM-DD'
                    }}
                    name={name}
                    value={currentVal}
                    onChange={updateDate}
                    onBlur={onBlur}
                    onClose={onBlur}
                    disabled={disabled}
                    autoOk
                    autoComplete="off"
                    error={error}
                    invalidDateMessage=""
                    variant="inline"
                    maxDateMessage=""
                    minDateMessage=""
                    clearable
                    cancelLabel={i18n.t('button.label.cancel')}
                    okLabel={''}
                    clearLabel={i18n.t('button.label.clear')}
                />
            )}
        </MuiPickersUtilsProvider>
    );
}

ResponseDatePicker.propTypes = {
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    error: PropTypes.bool,
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    disabled: PropTypes.bool,
    native: PropTypes.bool,
    lang: PropTypes.string,
    style: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

export default ResponseDatePicker;

const inputStyle = {
    width: '50%',
    [below('sm')]: {
        width: '100%'
    }
};
